<template>
  <div>
    <Header title="App Settings" subtitle="Admin dashboard application settings"/>
    <template v-if="!loading">
      <div :class="$style.items">
        <Card
            title="API Server Settings"
            direction="column"
            color="background"
            background="black"
            spacing="tad"
            as="section"
        >
          <TextComponent as="h2">
            Current Profile: {{currentProfile}}
          </TextComponent>

          <TextComponent as="p">
            API Base URL: {{settings.apiBaseURL}}
          </TextComponent>

          <TextComponent as="p">
            API Auth Provider: {{settings.apiAuthProvider}}
          </TextComponent>
        </Card>
        <Card
            title="Change API Connection"
            direction="column"
            color="background"
            background="black"
            spacing="tad"
            as="section">
          <ComboBox
              :options="profiles"
              style="color: black; min-width: 200px"
              description="Select a profile"
              label="Profile"
              name="profile_select"
              placeholder="Select a profile"
              v-model="update.selectedProfile"
          />
          <Input
              :class="$style.item"
              name="apiBaseURL"
              label="API Base URL"
              v-model="update.apiBaseURL"
          />
          <Input
              :class="$style.item"
              name="apiAuthProvider"
              label="API Auth Provider"
              v-model="update.apiAuthProvider"
          />

          <br />
          <Stack direction="row">
            <Button @click="updateSettings">
              Confirm Changes
            </Button>

            <Button @click="resetSettings">
              Reset to Production API
            </Button>
          </Stack>
        </Card>
      </div>

    </template>
    <template v-else>
      Loading...
    </template>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Input from '@hackthe6ix/vue-ui/Input';
  import TextComponent from '@hackthe6ix/vue-ui/Text/index';
  import ComboBox from '@hackthe6ix/vue-ui/ComboBox';
  import swal from 'sweetalert';
  import Card from '../../../containers/Card';
  import Header from '../../../containers/Header';
  import Stack from "@hackthe6ix/vue-ui/Stack";
  import {getCurrentProfile} from "@/utils/SessionController";
  import {getAPIAuthProvider, getAPIBaseURL} from "@/utils/api";

  export default {
    name: 'AppSettings',
    components: {
      TextComponent,
      Header,
      Button,
      Card,
      Input,
      ComboBox,
      Stack
    },
    data() {
      return {
        loading: true,
        currentProfile: "",
        settings: {
          apiBaseURL: "",
          apiAuthProvider: "",
          altAPIServers: []
        },
        update: {
          selectedProfile: "production",
          apiBaseURL: "",
          apiAuthProvider: ""
        }
      }
    },
    methods: {
      updateSettings() {
        localStorage.setItem("profile", this.update.selectedProfile);
        localStorage.setItem("apiBaseURL", this.update.apiBaseURL);
        localStorage.setItem("apiAuthProvider", this.update.apiAuthProvider);

        swal(
            'Success',
            `Switched to profile ${this.update.selectedProfile}. Click OK to reload.`,
            'success',
        ).then(() => {
          location.reload();
        });
      },
      resetSettings() {
        localStorage.removeItem("profile");
        localStorage.removeItem("apiBaseURL");
        localStorage.removeItem("apiAuthProvider");

        for (const keyName of Object.keys(localStorage)) {
          // delete all tokens other than production tokens
          if(keyName.endsWith("_token") || keyName.endsWith("_refreshToken")) {
            if(keyName !== "production_token" && keyName !== "production_refreshToken") {
              localStorage.removeItem(keyName);
            }
          }
        }

        swal(
            'Success',
            `API connection settings reset. Click OK to reload.`,
            'success',
        ).then(() => {
          location.reload();
        });
      }
    },
    computed: {
      profiles: function() {
        return ["production"].concat(this.settings.altAPIServers.map((ele) => ele.name));
      },
      profilesData: function() {
        const ret = {};
        for(const altServer of this.settings.altAPIServers) {
          ret[altServer.name] = altServer;
        }

        return ret;
      }
    },
    watch: {
      'update.selectedProfile': function(newProfile) {
        console.log(this.profilesData)
        this.update.apiBaseURL = this.profilesData[newProfile]?.address || process.env.VUE_APP_API_ADDRESS;
        this.update.apiAuthProvider = this.profilesData[newProfile]?.provider || process.env.VUE_APP_AUTH_PROVIDER;
      }
    },
    beforeMount() {
      this.currentProfile = getCurrentProfile();
      this.settings.apiBaseURL = getAPIBaseURL();
      this.settings.apiAuthProvider = getAPIAuthProvider();

      this.update.selectedProfile = getCurrentProfile();
      this.update.apiBaseURL = getAPIBaseURL();
      this.update.apiAuthProvider = getAPIAuthProvider();

      this.settings.altAPIServers = JSON.parse(atob(process.env.VUE_APP_ALT_API_DATA || "W10="));
      this.loading = false;
    },
  };
</script>

<style src="./AppSettings.module.scss" lang="scss" module/>
